import apiClient, { unwrap } from './client';

// Map API response shape to what the frontend expects
function toFrontend(record) {
  return {
    ...record,
    collectedBy: record.collectedById ?? record.collectedBy ?? null,
  };
}

export const eggRecordsApi = {
  getAll: async () => {
    const res = await apiClient.get('/egg-records', { params: { size: 1000, sort: 'date,desc' } });
    const page = unwrap(res);
    return (page?.content ?? page ?? []).map(toFrontend);
  },

  create: async (record) => {
    const res = await apiClient.post('/egg-records', record);
    return toFrontend(unwrap(res));
  },

  update: async (id, record) => {
    const res = await apiClient.put(`/egg-records/${id}`, record);
    return toFrontend(unwrap(res));
  },

  remove: async (id) => {
    await apiClient.delete(`/egg-records/${id}`);
  },
};
